import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
@Directive({
    selector: '[dianaNumberInputCheck]',
    standalone: false
})
/**
 * Used to force only positive numbers in the inputs
 */
export class NumberInputCheckDirective implements OnInit {
  @Input() totalDecimalCases = 2;
  @Input() allowNegative = false;

  private regex!: RegExp;
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  ngOnInit(): void {
    let negativeExp = '';
    if (this.allowNegative) {
      negativeExp = '[-]?';
    }
    if (this.totalDecimalCases) {
      this.regex = new RegExp("^" + negativeExp + "\\d*\\.?\\d{0," + this.totalDecimalCases + "}$", "g");
    } else {
      this.regex = new RegExp("^" + negativeExp + "[0-9]*$", "g");
    }
  }
}